import React, {useState} from 'react';
import {Col, Container, FormControl, InputGroup, Row} from "react-bootstrap";
import {CustomButton} from "../components";
import {MobileIcon} from "../assets";
import CheckBox from "../components/check-box";
import NextIcon from "../assets/next-icon";
import useAuth from "../hooks/useAuth";
import {FormProvider} from "../components/hook-form";
import useIsMountedRef from "../hooks/useIsMountedRef";
import {useForm} from "react-hook-form";
import {Backdrop, CircularProgress} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

function Login() {
    const {login} = useAuth();
    const [mobile, setMobile] = useState('');

    const isMountedRef = useIsMountedRef();

    const methods = useForm();

    const {
        reset,
        register,
        setError,
        handleSubmit,
        clearErrors,
        formState: {errors, isSubmitting},
    } = methods;
    let regex = new RegExp(/^[+]{1}(?:[0-9\-\(\)\/\.]\s?){6, 15}[0-9]{1}$/);
    const onSubmit = async (data) => {
        try {
            if (mobile !== null || regex.test(mobile) === true) {
                localStorage.setItem('mobile', mobile)
                await login(mobile);
            } else {
                console.log(mobile)
                setError('mobile', {
                    type: 'server',
                    message: 'شماره موبایل نامعتبر است!',
                });
            }

        } catch (error) {
            reset();
            if (isMountedRef.current) {

                setError('mobile', {
                    type: 'server',
                    message: error.message
                })
                if (error.errors?.mobile) {
                    setError('mobile', {
                        type: 'server',
                        message: error.errors.mobile[0],
                    });
                }

            }
        }

    };

    return (

        <div id="login-page">
            {isSubmitting && <Backdrop
                sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={true}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>}
            <div id="login-header">
                <img src={window.location.origin + '/assets/img/login-header.png'} alt=""/>
            </div>
            <Container>
                <h2 className="mt-4 page-title">ورود و ثبت نام</h2>
                <p className="page-hint">لطفا شماره موبایل خود را بدون صفر اول وارد کنید.</p>
                <>

                    <FormProvider noValidate methods={methods} onSubmit={handleSubmit(onSubmit)}>

                        <div className="login-input">
                            <InputGroup style={{
                                direction:'ltr'
                            }}>

                                <PhoneInput
                                    containerStyle={{
                                        width:'100%',
                                    }}
                                    inputStyle={{
                                        width:'100%',
                                    }}
                                    inputProps={{
                                        name: 'mobile',
                                        required: true,
                                        autoFocus: true
                                    }}
                                    value={mobile}
                                    onChange={(mobile) => setMobile(mobile)}

                                    country={"ir"}
                                    enableSearch={true}
                                    placeholder="شماره موبایل ..."

                                />

                            </InputGroup>
                            {errors.mobile && <p className="text-danger mb-0">{errors.mobile.message}</p>}

                        </div>

                        <Row className="d-flex justify-content-between mb-4 mt-3">
                            <Col>
                                <CheckBox id="remember" type="checkbox">
                       <span>
                            مرا بخاطر بسپار
                       </span>
                                </CheckBox>
                            </Col>
                            {/*   <Col className="d-flex justify-content-end">
                                <div>
                                    <Link className="forget-password-link" to={PATH_AUTH.resetPassword}>
                                        فراموشی رمز عبور
                                    </Link>
                                </div>
                            </Col>*/}
                        </Row>

                        <footer id="footer-section">
                            <CustomButton type="submit" onClick={() => clearErrors()}>
                                <NextIcon/>
                                <span> ورود به حساب</span>
                            </CustomButton>
                        </footer>

                    </FormProvider>


                </>
            </Container>
        </div>);
}

export default Login;
